import { render, staticRenderFns } from "./Index_Desktop.vue?vue&type=template&id=661c4a9c&scoped=true&"
import script from "./Index_Desktop.vue?vue&type=script&lang=js&"
export * from "./Index_Desktop.vue?vue&type=script&lang=js&"
import style0 from "./Index_Desktop.vue?vue&type=style&index=0&id=661c4a9c&prod&lang=css&"
import style1 from "./Index_Desktop.vue?vue&type=style&index=1&id=661c4a9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661c4a9c",
  null
  
)

export default component.exports